module.exports = __webpack_public_path__ + "img/by.ac31b781.svg";